
import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const JoinMissionSection = () => {
  return (
    <section className="py-16 md:py-24 bg-heaven-accent relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-[#1A1F2C] mb-6">
            Join the Mission
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-12">
            Ready to go deeper, bolder, stronger in your faith?<br />
            Start using Selah today. Truth is calling. Let's answer.
          </p>
          
          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6">
            <Button asChild size="lg" className="bg-heaven-gold hover:bg-heaven-dark-gold text-white">
              <Link to="/">Launch Selah</Link>
            </Button>
            
            <Button asChild size="lg" variant="outline" className="border-heaven-gold text-heaven-gold hover:bg-heaven-gold hover:text-white">
              <Link to="/bible-tools">See the Tools</Link>
            </Button>
            
            <Button asChild size="lg" variant="outline" className="border-heaven-gold text-heaven-gold hover:bg-heaven-gold hover:text-white">
              <Link to="/about">Join the Mission</Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
